// src/utils/time.js
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

// 注册 UTC 插件
dayjs.extend(utc)

/**
 * 将 UTC 时间字符串转换为本地时间并格式化输出
 * @param {string} utcTime - ISO 格式 UTC 时间（如 2025-07-09T10:30:04Z）
 * @param {string} format - 输出格式（默认 'YYYY/MM/DD HH:mm'）
 * @returns {string} 格式化后的本地时间字符串
 */
export function formatUtcToLocal(utcTime, format = 'MMMM D, YYYY [at] h:mm A') {
    if (!utcTime) return '';
    return dayjs.utc(utcTime).local().format(format);
}
